import React, { FC } from 'react';
import {
    StyledDateTimeDisplayWrapper,
    StyledLabel,
    StyledValue,
} from 'src/ui/white-labels/nftsuperlab/atoms/countdown/date-time-display/styles';

interface IProps {
    value: number;
    type: string;
}

export const DateTimeDisplay: FC<IProps> = ({ value, type }) => (
    <StyledDateTimeDisplayWrapper>
        <StyledValue>
            {value < 10 ? `0${value}` : value}
            {type !== 'sek' ? ':' : ''}
        </StyledValue>
        <StyledLabel>{type}</StyledLabel>
    </StyledDateTimeDisplayWrapper>
);
